import state from './OftenUse/states'
import mutations from './OftenUse/mutations'
import actions from './OftenUse/actions'
import getters from './OftenUse/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
